module.exports = __webpack_public_path__ + "img/mint-page-logo.7fa02ac3.png";